import { Button, Card } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

const WorkOrderForm = () => {
  return (
     <div>
            <Card size="small" title={<span style={{ color: 'white' }} >Work Order Form</span>}
          style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
          extra={<Link to='/work-order' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>}
          >
          Work order
            </Card>
        </div>
  )
}

export default WorkOrderForm